export default __webpack_public_path__ + "static/media/chandu.45bb6125.png";